import React, { useRef, useEffect } from "react";
import { Modal } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import SuccessImg from "../../../../assets/images/success-icon.png";
import useLangTranslation from "../../../customHooks/languageProvider";
import { setShowMessage, setCallFunOnGotIt } from "../../AxiosRtk/successMessage";
import { useDispatch } from "react-redux";

const SuccessMessageCommon = ({ showModal, defaultMessage, message, callFunOnGotIt = null }) => {
  const modalRef = useRef();
  const { getLangTranslation } = useLangTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log(showModal);
    if (showModal) {
      const modal = new Modal(modalRef.current, {
        backdrop: "static",
        keyboard: false,
      });
      modal.show();
    }
  }, [showModal]);

  const closeModal = () => {
    dispatch(
      setShowMessage({
        showMessage: false,
        defaultMessage: "",
        message: "",
      })
    );
    if(callFunOnGotIt) {
      callFunOnGotIt();
    } 
    // window.location.reload();
    dispatch(setCallFunOnGotIt(null));
  };

  return (
    <div className="modal fade" tabIndex="-1" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-sm">
        <div className="modal-content">
          <div className="modal-body">
            <img src={SuccessImg} className="mx-auto d-block mb-6" alt="..." />
            <h5 className="fw-bold mb-9 text-center">
              {message &&
                defaultMessage &&
                getLangTranslation(message, defaultMessage)}
            </h5>
            <button
              className="btn btn-primary w-100"
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            >
              <span className="btn-upper-case">
                {getLangTranslation("DEFAULT_SETTING_GOT_IT", "Got it")}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessMessageCommon;
